import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import Academics from 'views/admin/academics/Academics'
import TalkForm from './components/TalkForm'

const AcademicRoutes = () => {
  const { path } = useRouteMatch()
  return (
    <Switch>
      <Route exact path={path}>
        <Academics />
      </Route>
      <Route path={`${path}/new`}>
        <TalkForm />
      </Route>
      <Route path={`${path}/edit/:talkId`}>
        <TalkForm />
      </Route>
    </Switch>
  )
}

export default AcademicRoutes
